<template>
  <div class="redeem-content wd-p-5 xs:(wd-px-5 wd-py-1)">
    <div class="redeem-code-content">
      <div class="redeem-box">
        <p class="box-title mb-2">{{ redeemCodeTitle }}</p>
        <p class="redeem-text">{{ redeemCode }}</p>
      </div>

      <div class="redeem-hint-list mb-5">
        <ul>
          <li class="hint-list">{{ $t('redeem_code_tip2') }}</li>
          <li class="hint-list">{{ $t('redeem_code_tip3') }}</li>
        </ul>
      </div>
      <!-- 加入日曆 -->
      <v-btn class="calendar-btn wd-mb-2 text-white" color="orange50" height="40" variant="flat" block @click="openCalendar">
        {{ $t('add_to_calendar') }}
      </v-btn>
      <ModalCalendarAdder ref="calendarModal" :order="order" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalCalendarAdder from '@/components/ModalCalendarAdder.vue'

export default defineComponent({
  components: {
    ModalCalendarAdder,
  },
  props: {
    order: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()
    const calendarModal = ref(null)
    const redeemCodeTitle = computed(() => nuxtApp.$i18n.t('show_redeemcode'))
    const redeemCode = computed(() => props.order.redeem_code)

    function openCalendar() {
      calendarModal.value.showModal()
    }

    return {
      calendarModal,
      redeemCodeTitle,
      redeemCode,
      openCalendar,
    }
  },
  computed: {
    ...mapGetters({
      fromTngMiniProgram: 'fromTngMiniProgram',
    }),
  },
})
</script>
<style lang="scss" scoped>
.redeem-content {
  .cert-btn {
    &.disable {
      pointer-events: none;
    }
  }

  .redeem-box {
    text-align: center;
    .redeem-text {
      font-size: 36px;
      line-height: 1.22;
      color: $orange50;
    }
  }

  .redeem-hint-list {
    .hint-list {
      margin-bottom: 8px;
    }
  }
}
</style>
